// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyA6FyE-Xub5X2pxNs2ow1dJMgqNndSWOmo',
    authDomain: 'bytpher-pidelo-ya.firebaseapp.com',
    databaseURL: 'https://bytpher-pidelo-ya.firebaseio.com',
    projectId: 'bytpher-pidelo-ya',
    storageBucket: 'bytpher-pidelo-ya.appspot.com',
    messagingSenderId: '1013326598316',
    appId: '1:1013326598316:web:7232f8b785e30d82518f09',
    measurementId: 'G-88GLM250R7',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
